import React, { useState, useMemo, useEffect } from "react";
import { Container, UncontrolledTooltip, Form, FormGroup, Label, Input, Button, Row, Col, Card, CardBody } from "reactstrap";
import TableContainer from "components/Common/TableContainer";
import { useTranslation } from "react-i18next";

// Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";

import { Link } from "react-router-dom";
import * as Yup from "yup";
import { Formik, ErrorMessage, Field } from "formik";
import Select from 'react-select'
import { useDispatch, useSelector } from "react-redux";
import { fetchActiveEmployees, fetchEmployeeDropdown, fetchMultilevelApprovalRequest, saveMultilevelApprovalRequest, toggleApprovalStatusRequest } from "store/actions";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import CustomSelect from "components/Common/custom-select";
import { leaveCategory } from "common/data/constants";
import Swal from "sweetalert2";
import Loader from "common/pageLoader";
import { useLocation,useHistory } from "react-router-dom";
import getAccessRights from "components/Common/getAccessRights";
import useButtonAccess from "components/Common/useButtonAccess";

const approvalLevelOptions = [
    { value: 1, label: "1" },
    { value: 2, label: "2" },
    { value: 3, label: "3" },
    { value: 4, label: "4" },
    { value: 5, label: "5" },
];

const handleCancelConfirm = async (resetForm, dirty) => {
    // If no changes → reset directly
    if (!dirty) {
        resetForm();
        return;
    }
 
    const result = await Swal.fire({
        title: "Confirm Cancel",
        text: "All entered data will be cleared. Do you want to continue?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        confirmButtonColor: "rgb(145, 73, 234)",
        cancelButtonColor: "#6c757d",
    });
 
    if (result.isConfirmed) {
        resetForm();
    }
};

const MultiLevelApproval = () => {
    const [accessRight, setAccessRight] = useState(null);
    const location = useLocation();
    const history = useHistory();
    useEffect(() => {
        const rights = getAccessRights(location.pathname, history);
        setAccessRight(rights?.data);
    }, [location]);
    const { canRead, canCreate, canEdit, canDelete } = useButtonAccess(accessRight);
    const dispatch = useDispatch();
    const [authDetails, setAuthDetails] = useState(null);
    const {
        multilevel_approvals,
        employees,
        dropdownData,
        loading,
        success,
        error,
    } = useSelector((state) => ({
        multilevel_approvals: state.EmployeeMultiLevelReducer?.multilevel_approvals ?? [],
        employees: state.EmployeeDetailsReducer?.employeesActiveList ?? [],
        dropdownData: state.EmployeeDetailsReducer?.dropdownData ?? [],

        loading: state.EmployeeMultiLevelReducer?.loading || state.EmployeeDetailsReducer?.loading,
        error: state.EmployeeMultiLevelReducer?.error || state.EmployeeDetailsReducer?.error,
        success: state.EmployeeMultiLevelReducer?.success,
    }));
    const { approve_by } = dropdownData;

    useEffect(() => {
        const authUserDetails = useAuthUserDetails();
        setAuthDetails(authUserDetails[0])
        const unitId = authUserDetails[0].unit_id
        dispatch(fetchMultilevelApprovalRequest(unitId));
        dispatch(fetchActiveEmployees(unitId))
        dispatch(fetchEmployeeDropdown(unitId))
    }, [dispatch]);

    useEffect(() => {
        if (success) {
            dispatch(fetchMultilevelApprovalRequest(authDetails?.unit_id));
        }
    }, [authDetails, success, dispatch]);

    // const columns = useMemo(() => [
    //     {
    //         Header: "Action",
    //         className: "serial-no",
    //         applyHeaderClass: true,
    //         Cell: (cellProps) => {
    //             const { b_active, approval_id } = cellProps.row.original;
    //             const isActive = b_active === 1; // Status 1 = Active
    //             return (
    //                 <div className="d-flex gap-3">
    //                     <Link
    //                         to="#"
    //                         style={{ color: isActive ? "green" : "red" }}
    //                         onClick={() => handleToggleStatus(approval_id, isActive)}
    //                     >
    //                         <i
    //                             className={`mdi ${isActive ? "mdi-check-circle" : "mdi-close-circle"} font-size-18`}
    //                             id={`status-tooltip-${cellProps.row.id}`}
    //                         />
    //                         <UncontrolledTooltip placement="top" target={`status-tooltip-${cellProps.row.id}`}>
    //                             {isActive ? "Mark Inactive" : "Mark Active"}
    //                         </UncontrolledTooltip>
    //                     </Link>
    //                     {/* <Link
    //                         to="#"
    //                         className="text-success"
    //                         onClick={() => handleEdit(cellProps.row.original)}
    //                     >
    //                         <i className="bx bxs-edit font-size-18" id="edittooltip" />
    //                         <UncontrolledTooltip placement="top" target="edittooltip">
    //                             Edit
    //                         </UncontrolledTooltip>
    //                     </Link> */}
    //                 </div>
    //             );
    //         },
    //     },
    //     {
    //         Header: "S.No",
    //         Cell: ({ row }) => multilevel_approvals.length - row.index,
    //         className: "serial-no",
    //         applyHeaderClass: true,
    //     },
    //     {
    //         Header: "Code",
    //         accessor: "emp_no",
    //     },
    //     {
    //         Header: "Name",
    //         accessor: "emp_name",
    //     },
    //     {
    //         Header: "Type",
    //         accessor: "app_type", // Format Date properly
    //     },
    //     {
    //         Header: "Approval Level",
    //         accessor: "app_levels",
    //     },
    //     {
    //         Header: "Approver Code",
    //         accessor: "app_empno",
    //     },
    //     {
    //         Header: "Approver Name",
    //         accessor: "approver_name",
    //     },
    //     {
    //         Header: "Created By",
    //         accessor: "create_by",
    //     },
    //     {
    //         Header: "Created On",
    //         accessor: "created_dt",

    //     },
    // ]);

    const columns = useMemo(() => {
        const cols = [];

        // 👉 Show Action column ONLY if canEdit = true
        if (canEdit) {
            cols.push({
                Header: "Action",
                className: "serial-no",
                applyHeaderClass: true,
                Cell: (cellProps) => {
                    const { b_active, approval_id } = cellProps.row.original;
                    const isActive = b_active === 1;

                    return (
                        <div className="d-flex gap-3">
                            <Link
                                to="#"
                                style={{ color: isActive ? "green" : "red" }}
                                onClick={() => handleToggleStatus(approval_id, isActive)}
                            >
                                <i
                                    className={`mdi ${isActive ? "mdi-check-circle" : "mdi-close-circle"} font-size-18`}
                                    id={`status-tooltip-${cellProps.row.id}`}
                                />
                                <UncontrolledTooltip placement="top" target={`status-tooltip-${cellProps.row.id}`}>
                                    {isActive ? "Mark Inactive" : "Mark Active"}
                                </UncontrolledTooltip>
                            </Link>
                        </div>
                    );
                },
            });
        }

        // 👉 Other Columns (always visible)
        cols.push(
            {
                Header: "S.No",
                Cell: ({ row }) => multilevel_approvals.length - row.index,
                className: "serial-no",
                applyHeaderClass: true
            },
            { Header: "Code", accessor: "emp_no" },
            { Header: "Name", accessor: "emp_name" },
            { Header: "Type", accessor: "app_type" },
            { Header: "Approval Level", accessor: "app_levels" },
            { Header: "Approver Code", accessor: "app_empno" },
            { Header: "Approver Name", accessor: "approver_name" },
            { Header: "Created By", accessor: "create_by" },
            { Header: "Created On", accessor: "created_dt" }
        );

        return cols;
    }, [canEdit, multilevel_approvals]);

    const handleToggleStatus = (approval_id, isActive) => {
        Swal.fire({
            title: 'Are you sure?',
            text: `You are about to ${isActive ? 'deactivate' : 'activate'} this.`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Confirm',
            cancelButtonText: 'Cancel',
            reverseButtons: false,
            dangerMode: true,
        }).then((result) => {
            if (result.isConfirmed) {
                const formData = new FormData();
                formData.append("approval_id", approval_id);
                formData.append("create_by", authDetails?.user_id);
                dispatch(toggleApprovalStatusRequest(formData));
            }
        });
    };

    const validationSchema = Yup.object({
        employeeCode: Yup.object().required("Employee Code is required"),
        type: Yup.object().required("Type is required"),
        approvalLevel: Yup.object().required("Approval Level is required"),
        approvalCode: Yup.object().required("Approval Code is required"),
    });

    const handleSubmit = (values, { resetForm }) => {
        const formData = new FormData();
        formData.append("approval_id", 0);
        formData.append("emp_id", values.employeeCode?.value);
        formData.append("type_id", values.type.value);
        formData.append("app_levels", values.approvalLevel?.value);
        formData.append("app_emp_id", values.approvalCode?.value);
        formData.append("unit_id", authDetails?.unit_id);
        formData.append("create_by", authDetails?.user_id);
        dispatch(saveMultilevelApprovalRequest(formData))
    };

    const SelectcustomStyles = {
        control: (base) => ({ ...base, minHeight: 33.1, maxHeight: 33.1 }),
        dropdownIndicator: (base) => ({ ...base, padding: "2px 8px" }),
        clearIndicator: (base) => ({ ...base, padding: "2px 8px" }),
        valueContainer: (base) => ({ ...base, padding: "0px 8px" }),
        input: (base) => ({ ...base, margin: 0, padding: 0 }),
    };

    
    return (
        <React.Fragment>
            <div className="page-content">
                <Loader loading={loading} />
                <Container fluid>
                    <Breadcrumbs title="Organizational Setup" breadcrumbItem="Multilevel Approval" />

                    <Row>
                        <Col lg="12">
                        {(canRead && canCreate) && (
                            <Card>
                                <CardBody>
                                    <Formik
                                        initialValues={{
                                            employeeCode: "",
                                            type: '',
                                            approvalLevel: '',
                                            approvalCode: "",
                                        }}
                                        validationSchema={validationSchema}
                                        onSubmit={handleSubmit}
                                    >
                                        {({ values, setFieldValue, handleSubmit, resetForm, dirty }) => (
                                            <Form onSubmit={handleSubmit}>
                                                <Row>
                                                    <Col md={3}>
                                                        <FormGroup>
                                                            <Label for="employeeCode">
                                                                Employee Code <span className="text-danger">*</span>
                                                            </Label>
                                                            <CustomSelect
                                                                options={employees}
                                                                name="employeeCode"
                                                                value={values.employeeCode || null} // Store full object
                                                                onChange={(selectedOption) => setFieldValue("employeeCode", selectedOption)}
                                                                styles={SelectcustomStyles}
                                                            />
                                                            <ErrorMessage
                                                                name="employeeCode"
                                                                component="div"
                                                                className="text-danger"
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md={3}>
                                                        <FormGroup>
                                                            <Label for="type">
                                                                Type <span className="text-danger">*</span>
                                                            </Label>
                                                            <Select
                                                                id="type"
                                                                options={leaveCategory}
                                                                value={values.type}
                                                                onChange={(option) => setFieldValue("type", option)}
                                                                styles={SelectcustomStyles}
                                                                className="hrms-select"
                                                                classNamePrefix="hrms-select"
                                                            />
                                                            <ErrorMessage
                                                                name="type"
                                                                component="div"
                                                                className="text-danger"
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md={3}>
                                                        <FormGroup>
                                                            <Label for="approvalLevel">
                                                                Approval Level <span className="text-danger">*</span>
                                                            </Label>
                                                            <Select
                                                                id="approvalLevel"
                                                                options={approvalLevelOptions}
                                                                value={values.approvalLevel}
                                                                onChange={(option) => setFieldValue("approvalLevel", option)}
                                                                styles={SelectcustomStyles}
                                                                className="hrms-select"
                                                                classNamePrefix="hrms-select"
                                                            />
                                                            <ErrorMessage
                                                                name="approvalLevel"
                                                                component="div"
                                                                className="text-danger"
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md={3}>
                                                        <FormGroup>
                                                            <Label for="approvalCode">
                                                                Approval Code <span className="text-danger">*</span>
                                                            </Label>
                                                            <CustomSelect
                                                                options={(approve_by || []).map(emp => ({ value: emp.report_id, label: emp.report_name }))}
                                                                name="approvalCode"
                                                                value={values.approvalCode || null} // Store full object
                                                                onChange={(selectedOption) => setFieldValue("approvalCode", selectedOption)}
                                                                styles={SelectcustomStyles}
                                                            />
                                                            <ErrorMessage
                                                                name="approvalCode"
                                                                component="div"
                                                                className="text-danger"
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <Col md="12" className="d-flex mob-center align-items-center justify-content-end mt-2">
                                                    <Button type="submit" className="btn button-save  me-2">
                                                        <i className="fas fa-save me-1" /> Save
                                                    </Button>
                                                        <Button
                                                            type="button"
                                                            onClick={() => handleCancelConfirm(resetForm, dirty)}
                                                            className="btn button-cancel"
                                                        >
                                                            <i className="fas fa-sync me-1" /> Cancel
                                                        </Button>
                                                </Col>
                                            </Form>
                                        )}
                                    </Formik>
                                </CardBody>
                                </Card>
                                )}

                                <Card>
                                    <CardBody>
                                        <TableContainer
                                            columns={columns}
                                            data={multilevel_approvals && multilevel_approvals.length > 0 ? multilevel_approvals : []}
                                            isGlobalFilter={true}
                                            customPageSize={10}
                                            className="custom-header-css"
                                        />
                                    </CardBody>
                                </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>

    );
};

export default MultiLevelApproval;
